export const CALENDAR_MODE = {
  WEEK: 'week',
  MONTH: 'month',
};
